'use client';

import { c as _c } from "react/compiler-runtime";
import { m } from 'motion/react';
import { RANGES, RANGE_LABELS, type RotationRange } from '@/lib/rotation/types';
export function RotationRanges(t0) {
  const $ = _c(6);
  const {
    range,
    disabled,
    onChange
  } = t0;
  let t1;
  if ($[0] !== disabled || $[1] !== onChange || $[2] !== range) {
    t1 = RANGES.map(value => <button key={value} aria-pressed={range === value} disabled={disabled} className={range === value ? "selected" : ""} onClick={() => onChange(value)}>{RANGE_LABELS[value]}{range === value && <m.span layoutId="rotation-range-dot" className="rotation-range-dot" transition={{
        type: "spring",
        stiffness: 400,
        damping: 34
      }} />}</button>);
    $[0] = disabled;
    $[1] = onChange;
    $[2] = range;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <nav className="rotation-ranges" aria-label="Listening period">{t1}</nav>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}